<template>
  <div class="unauthorized">
    <b-row>
      <h2>Unauthorized</h2>
    </b-row>
    <b-img
      center
      src="https://whatsticker.online/stickers_asset/ws-pack-36/c1eae0c4c5-1010.png"
      width="300" />
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
}
</script>
